import React, { useState, useEffect } from "react";
import { StarFilled } from "@ant-design/icons";
import { Skeleton } from "antd";
import APIService from "../../services/APIService";
import Heading from "../Heading";
import { Link } from "react-router-dom";

export default function TopSellToday() {
  const [dataSell, setDataSell] = useState(["", "", "", "", ""]);

  async function getSellList() {
    const RESULT = await APIService.getSellList(1, 5);
    if (RESULT) {
      setDataSell(RESULT.data);
    }
  }

  useEffect(() => {
    getSellList();
  }, []);

  return dataSell.length ?
    <div className="w-full">
      <Heading
        title="Top đại lý/Npp bán hàng hôm nay"
        isShowButtonMore={false}
        className="text-[#222222]"
      ></Heading>
      <div className="w-full h-[5px] bg-[#EBEBEB] mt-3 mb-3">
        <div className="w-1/4 h-full rounded-full bg-[#119AE2]"></div>
      </div>
      <div className="flex gap-y-[10px] flex-col">
        {dataSell.map((item, index) =>
          item.id ? (
            <Link to={`/agency-details?agencyId=${item.id}`} key={index}>
              <div className="flex flex-1">
                <div className="w-[45px] h-[45px] flex justify-center items-center bg-[#119AE2]">
                  <StarFilled
                    className="text-yellow-300"
                    style={{ fontSize: 18 }}
                  />
                </div>
                <div className="flex flex-1 flex-col px-3 bg-[#F3F3F3] justify-center">
                  <p className="text-sm text-[#222222] font-semibold text-one-lines">{item.name}</p>
                  <p className="text-one-lines text-[10px] text-[#8A8A8A]">{item.address}</p>
                </div>
              </div>
            </Link>
          ) : (
            <Skeleton.Button
              style={{
                height: 45,
              }}
              key={index}
              active
              block={true}
              size="large"
            />
          )
        )}
      </div>
    </div> : <></>
}
